var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyCompany(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "my_company",
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M0,0H65V65H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M29.167,13.889V8.444A5.455,5.455,0,0,0,23.733,3H7.433A5.455,5.455,0,0,0,2,8.444V46.556A5.455,5.455,0,0,0,7.433,52H50.9a5.455,5.455,0,0,0,5.433-5.444V19.333A5.455,5.455,0,0,0,50.9,13.889Zm-16.3,32.667H7.433V41.111h5.433Zm0-10.889H7.433V30.222h5.433Zm0-10.889H7.433V19.333h5.433Zm0-10.889H7.433V8.444h5.433ZM23.733,46.556H18.3V41.111h5.433Zm0-10.889H18.3V30.222h5.433Zm0-10.889H18.3V19.333h5.433Zm0-10.889H18.3V8.444h5.433Zm24.45,32.667H29.167V41.111H34.6V35.667H29.167V30.222H34.6V24.778H29.167V19.333H48.183A2.727,2.727,0,0,1,50.9,22.056V43.833A2.727,2.727,0,0,1,48.183,46.556ZM45.467,24.778H40.033v5.444h5.433Zm0,10.889H40.033v5.444h5.433Z",
    transform: "translate(3.333 5)",
    fill: "#374955"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyCompany);
export default __webpack_public_path__ + "static/media/my_company.9c5010253579ab40b9725ba83e312415.svg";
export { ForwardRef as ReactComponent };